import { dataProps } from './properties'

export const setContraEntryList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    state.nav.total_amount = payload.total_amount
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setContraEntryData = (state, payload) => {
    state.props = payload
} 

export const resetContraEntryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/contraEntry/mutations.js